var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.formItemClasss }, [
    _c("label", { class: _vm.labelClasss, style: _vm.labelStyle }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mku-form-item__content" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm.isShowMessage
          ? _c("p", { staticClass: "mku-form-item__error" }, [
              _vm._v("\n      " + _vm._s(_vm.validateMessage) + "\n    ")
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }